var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 1.16667C4.66667 1.07462 4.59205 1 4.5 1H1.16667C1.07462 1 1 1.07462 1 1.16667V5.83333C1 5.92538 1.07462 6 1.16667 6H4.5C4.59205 6 4.66667 5.92538 4.66667 5.83333V1.16667ZM5.66667 5.83333C5.66667 6.47767 5.14433 7 4.5 7H1.16667C0.522334 7 0 6.47767 0 5.83333V1.16667C0 0.522334 0.522334 0 1.16667 0H4.5C5.14433 0 5.66667 0.522334 5.66667 1.16667V5.83333Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.16667C12 1.07462 11.9254 1 11.8333 1H8.5C8.40795 1 8.33333 1.07462 8.33333 1.16667V3.16667C8.33333 3.25871 8.40795 3.33333 8.5 3.33333H11.8333C11.9254 3.33333 12 3.25871 12 3.16667V1.16667ZM13 3.16667C13 3.811 12.4777 4.33333 11.8333 4.33333H8.5C7.85567 4.33333 7.33333 3.811 7.33333 3.16667V1.16667C7.33333 0.522334 7.85567 0 8.5 0H11.8333C12.4777 0 13 0.522334 13 1.16667V3.16667Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.16667C12 7.07462 11.9254 7 11.8333 7H8.5C8.40795 7 8.33333 7.07462 8.33333 7.16667V11.8333C8.33333 11.9254 8.40795 12 8.5 12H11.8333C11.9254 12 12 11.9254 12 11.8333V7.16667ZM13 11.8333C13 12.4777 12.4777 13 11.8333 13H8.5C7.85567 13 7.33333 12.4777 7.33333 11.8333V7.16667C7.33333 6.52233 7.85567 6 8.5 6H11.8333C12.4777 6 13 6.52233 13 7.16667V11.8333Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 9.83333C4.66667 9.74129 4.59205 9.66667 4.5 9.66667H1.16667C1.07462 9.66667 1 9.74129 1 9.83333V11.8333C1 11.9254 1.07462 12 1.16667 12H4.5C4.59205 12 4.66667 11.9254 4.66667 11.8333V9.83333ZM5.66667 11.8333C5.66667 12.4777 5.14433 13 4.5 13H1.16667C0.522334 13 0 12.4777 0 11.8333V9.83333C0 9.189 0.522334 8.66667 1.16667 8.66667H4.5C5.14433 8.66667 5.66667 9.189 5.66667 9.83333V11.8333Z",
    fill: "#0A0A0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDashboard);
export default __webpack_public_path__ + "static/media/btn-dashboard.db369a428bd97b3b55c1fdcfb65bd916.svg";
export { ForwardRef as ReactComponent };